import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"

export const getScheduleEditorDraftAmends = api(async function getScheduleEditorDraftAmends({ projectId, scheduleId }) {
    if (!projectId || !scheduleId) return { draftStatus: null, persistedAmends: [], inheritedAmends: [] }

    return query(
        gql`
            query GetScheduleEditorDraftAmends($projectId: String!, $scheduleId: String!) {
                getScheduleEditorDraftAmends(projectId: $projectId, scheduleId: $scheduleId) {
                    draftStatus
                    persistedAmends {
                        id
                        referenceId
                        shortDescription
                        longDescription
                        type
                        payload
                        userId
                        userName
                        clientId
                        modified
                        date
                    }
                    inheritedAmends {
                        id
                        referenceId
                        shortDescription
                        longDescription
                        type
                        payload
                        userId
                        userName
                        clientId
                        modified
                        date
                    }
                }
            }
        `,
        { projectId, scheduleId },
        { returns: "getScheduleEditorDraftAmends" }
    )
})
